module.exports = __webpack_public_path__ + "img/loading-ring.eace43bd.gif";